/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Month_DecemberInputs */

const he_month_december = /** @type {(inputs: Month_DecemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`דצמבר`)
};

const en_month_december = /** @type {(inputs: Month_DecemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`December`)
};

/**
* | output |
* | --- |
* | "December" |
*
* @param {Month_DecemberInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const month_december = /** @type {((inputs?: Month_DecemberInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Month_DecemberInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_month_december(inputs)
	return en_month_december(inputs)
});